import script from "./kitchenManage.vue?vue&type=script&setup=true&lang=js"
export * from "./kitchenManage.vue?vue&type=script&setup=true&lang=js"

import "./kitchenManage.vue?vue&type=style&index=0&id=27c214a3&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c214a3"]])

export default __exports__